import { useMemo } from "react";

import { getCanonicalLanguage, SUPPORTED_LANGUAGES } from "@corca/tiptap";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";

import type { DocumentModel } from "@/models/DocumentModel";

export const CodeLanguageSelector = observer(function CodeLanguageSelector({
  doc,
}: {
  doc: DocumentModel;
}) {
  const t = useTranslations("sidebar.blocks.code");
  const grammarsT = useTranslations("grammars");

  const { tiptap, editorState } = doc.editor;

  const items = useMemo(() => {
    return SUPPORTED_LANGUAGES.map((lang) => {
      const canonicalLang = getCanonicalLanguage(lang);
      return {
        title: canonicalLang ? grammarsT(canonicalLang) : "",
        onClick: () => {
          tiptap?.commands.updateAttributes("codeBlock", { language: canonicalLang });
        },
      };
    });
  }, [tiptap, grammarsT]);

  const { language } = editorState.codeBlockAttrs ?? {};
  const canonicalLanguage = getCanonicalLanguage(language);

  return (
    <Dropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          id="code-block-language"
          as="div"
          title={canonicalLanguage ? grammarsT(canonicalLanguage) : t("selectLanguage")}
          tooltipTitle={t("language")}
        />
      }
      items={items}
      itemsClassName="min-w-[150px]"
    />
  );
});
